document.addEventListener('DOMContentLoaded', () => {
  // JavaScript logic

  const fullPricePerBox = Number(window.fullPriceBox) || 44.99;
  let leastExpensiveBox = fullPricePerBox;
  let currentSelectedProduct = window.defaultSelectedProduct || null;
  let selectedShipFrequency = window.defaultShipFrequency || null;
  let moneySign =
    document.querySelector('.num-received-container li').dataset
      .productPrice[0] ?? '$';

  const primaryAddToCartBtn = document.querySelector('#primary-add-to-cart');
  const mobileAddToCartBtn = document.querySelector('#mobile-add-to-cart');
  const primaryAddToCartGiftBtn = document.querySelector(
    '#primary-add-to-cart-gift'
  );
  const mobileAddToCartGiftBtn = document.querySelector(
    '#mobile-add-to-cart-gift'
  );
  const productDropdownBtn = document.querySelector(
    '.custom-dropdown-btn.product'
  );
  const productDropdownMenu = document.querySelector(
    '.custom-dropdown-menu.product'
  );

  const shipDropdownBtn = document.querySelector('.custom-dropdown-btn.ship');
  const shipDropdownMenu = document.querySelector('.custom-dropdown-menu.ship');

  const enableAddToCartButtons = () => {
    primaryAddToCartBtn.disabled = false;
    mobileAddToCartBtn.disabled = false;
    primaryAddToCartBtn.classList.remove('disabled');
    mobileAddToCartBtn.classList.remove('disabled');

    primaryAddToCartGiftBtn.disabled = false;
    mobileAddToCartGiftBtn.disabled = false;
    primaryAddToCartGiftBtn.classList.remove('disabled');
    mobileAddToCartGiftBtn.classList.remove('disabled');
  };

  const disableAddToCartButtons = () => {
    primaryAddToCartBtn.disabled = true;
    mobileAddToCartBtn.disabled = true;
    primaryAddToCartBtn.classList.add('disabled');
    mobileAddToCartBtn.classList.add('disabled');

    primaryAddToCartGiftBtn.disabled = true;
    mobileAddToCartGiftBtn.disabled = true;
    primaryAddToCartGiftBtn.classList.add('disabled');
    mobileAddToCartGiftBtn.classList.add('disabled');
  };

  const findMatchingProduct = (numReceived, shipFrequency) => {
    return Array.from(dropdownMenuItems).find(
      item =>
        Number(item.dataset.numReceived) === Number(numReceived) &&
        Number(item.dataset.shipFrequencyProduct) === Number(shipFrequency)
    );
  };

  const selectShipFrequency = (target, isInitialLoad = false) => {
    shipDropdownBtn.innerHTML = target.innerHTML;
    selectedShipFrequency = target.dataset.value;
    shipDropdownMenu.classList.remove('show');
    updateVisibleItems(isInitialLoad);
  };

  const selectProduct = (target, isInitialLoad = false) => {
    if (isInitialLoad) {
      productDropdownBtn.innerHTML =
        currentSelectedProduct?.label || 'Select a plan';
      return;
    }

    if (!target && !isInitialLoad) {
      currentSelectedProduct = null;
      productDropdownBtn.innerHTML = 'Select a plan';
      disableAddToCartButtons();
      return;
    }

    const productId = target.dataset.value;
    const sellingPlanId = target.dataset.sellingPlan;
    const numReceived = target.dataset.numReceived;
    const shipFrequency = target.dataset.shipFrequencyProduct;
    productDropdownBtn.innerHTML = target.innerHTML;
    productDropdownMenu.classList.remove('show');

    const newProduct = {
      label: target.innerHTML,
      productId,
      sellingPlanId,
      numReceived,
      shipFrequency,
    };
    currentSelectedProduct = newProduct;
    enableAddToCartButtons();
  };

  productDropdownBtn.addEventListener('click', () => {
    productDropdownMenu.classList.toggle('show');
  });

  shipDropdownBtn.addEventListener('click', () => {
    shipDropdownMenu.classList.toggle('show');
  });

  const dropdownMenuItems = document.querySelectorAll(
    '.custom-dropdown-menu.product li'
  );

  dropdownMenuItems.forEach(item => {
    item.addEventListener('click', e => {
      const liElement = e.target.closest('li');
      selectProduct(liElement);
    });
  });

  // on load, hide all of the dropdownMenu li elements that don't have the data-ship-frequency-product attribute equal to the current value of #ship-frequency-select
  const updateVisibleItems = (isInitialLoad = false) => {
    const currentShipFrequency = selectedShipFrequency;
    dropdownMenuItems.forEach(item => {
      if (
        Number(item.dataset.shipFrequencyProduct) ===
        Number(currentShipFrequency)
      ) {
        item.style.display = '';
      } else {
        item.style.display = 'none';
      }
    });

    // if there is a product selected, call selectProduct with the option element that has the same data-num-received value as the current selected product and the same data-ship-frequency-product value as the current value of #ship-frequency-select
    if (currentSelectedProduct) {
      const currentNumReceived = currentSelectedProduct.numReceived;
      const matchingItem = findMatchingProduct(
        currentNumReceived,
        currentShipFrequency
      );

      selectProduct(matchingItem || null, isInitialLoad);
    }
  };

  const dropdownShipItems = document.querySelectorAll(
    '.custom-dropdown-menu.ship li'
  );

  dropdownShipItems.forEach(item => {
    item.addEventListener('click', e => {
      const liElement = e.target.closest('li');
      selectShipFrequency(liElement);
    });
  });

  primaryAddToCartBtn.addEventListener('click', async function (e) {
    await prepaidAddToCart(
      currentSelectedProduct.productId,
      currentSelectedProduct.sellingPlanId
    );
  });

  mobileAddToCartBtn.addEventListener('click', async function (e) {
    await prepaidAddToCart(
      currentSelectedProduct.productId,
      currentSelectedProduct.sellingPlanId
    );
  });

  primaryAddToCartGiftBtn.addEventListener('click', async function (e) {
    document
      .querySelector(`#gift_modal_${currentSelectedProduct.productId}`)
      .show(e.target);
    // await prepaidAddToCart(selectedProduct, selectedSellingPlan, true);
  });

  mobileAddToCartGiftBtn.addEventListener('click', async function (e) {
    await prepaidAddToCart(
      currentSelectedProduct.productId,
      currentSelectedProduct.sellingPlanId,
      true
    );
  });

  async function prepaidAddToCart(
    productId,
    sellingPlan = null,
    isGift = false
  ) {
    const body = {
      id: productId,
      quantity: 1,
      properties: {
        _is_subscription: true,
      },
    };

    if (isGift) {
      body.properties = {
        ...body.properties,
        _is_gift: true,
      };
    }

    if (!!sellingPlan) {
      body.selling_plan = sellingPlan;
    }

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });
    await response.json();
  }

  const calculateSavePercentage = (productPrice, numBoxes) => {
    const pricePerThisBox = Number(productPrice) / Number(numBoxes);
    const savePercentage =
      ((fullPricePerBox - pricePerThisBox) / fullPricePerBox) * 100;
    return savePercentage.toFixed(0);
  };

  const applySavePercentageBadge = item => {
    const savePercentage = calculateSavePercentage(
      item.dataset.productPriceNumber,
      item.dataset.numReceived
    );

    const badge = item.querySelector('.save-percentage-badge');
    if (!badge) return;

    if (savePercentage > 0) {
      badge.style.display = 'flex';
      const badgePercentage = badge.querySelector('.percentage-amount');
      if (badgePercentage) {
        badgePercentage.textContent = `${savePercentage}%`;
      }
    } else {
      badge.style.display = 'none';
    }
  };

  // Run on initial load
  dropdownMenuItems.forEach(item => {
    const price = item.dataset.productPrice;
    const numReceived = item.dataset.numReceived;
    const pricePerBox = parseFloat(
      parseFloat(price.replace(moneySign, '')) / Number(numReceived)
    ).toFixed(2);
    leastExpensiveBox = Math.min(leastExpensiveBox, pricePerBox);
    applySavePercentageBadge(item);
  });

  const leastExpensiveBoxEl = document.querySelector('#least-expensive-box');
  if (leastExpensiveBoxEl) {
    leastExpensiveBoxEl.innerHTML = moneySign + leastExpensiveBox;
  }

  let defaultShipFrequencyEl = shipDropdownMenu.querySelector(
    `li[data-value="${selectedShipFrequency}"]`
  );
  if (!defaultShipFrequencyEl) {
    defaultShipFrequencyEl = shipDropdownMenu.querySelector('li[data-value]');
  }
  if (defaultShipFrequencyEl) {
    selectShipFrequency(defaultShipFrequencyEl, true);
  }
  if (currentSelectedProduct) {
    enableAddToCartButtons();
  }
});
